//#region assets/inline-svg.ts
/**
* Replaces <img data-inline-svg> with inline <svg> markup.
* Needed for logo SVGs so they are present as raw markup in DOM.
*/
function viewBoxAspectRatio(svg) {
	const viewBox = svg.getAttribute("viewBox");
	if (!viewBox) return null;
	const parts = viewBox.trim().split(/[\s,]+/).map(Number);
	if (parts.length !== 4) return null;
	const [, , width, height] = parts;
	if (!(width > 0) || !(height > 0)) return null;
	return width / height;
}
/**
* Copy sizing/a11y attrs from the placeholder <img> onto the fetched <svg>.
* Source SVG width/height must be cleared first — keeping e.g. width="212"
* after overwriting height="30"→"36" shrinks the logo vs the <img> render.
*/
function applyAttributesFromImage(img, svg) {
	const className = img.getAttribute("class");
	const style = img.getAttribute("style");
	const alt = img.getAttribute("alt");
	const role = img.getAttribute("role");
	let width = img.getAttribute("width");
	let height = img.getAttribute("height");
	svg.removeAttribute("width");
	svg.removeAttribute("height");
	if (height && !width) {
		const aspect = viewBoxAspectRatio(svg);
		if (aspect) width = String(Math.round(Number(height) * aspect));
	} else if (width && !height) {
		const aspect = viewBoxAspectRatio(svg);
		if (aspect) height = String(Math.round(Number(width) / aspect));
	}
	if (className) svg.setAttribute("class", className);
	if (style) svg.setAttribute("style", style);
	if (width) svg.setAttribute("width", width);
	if (height) svg.setAttribute("height", height);
	if (role) svg.setAttribute("role", role);
	if (alt && alt.trim() !== "") {
		svg.setAttribute("role", "img");
		svg.setAttribute("aria-label", alt);
	} else svg.setAttribute("aria-hidden", "true");
}
async function inlineSvgImage(img) {
	if (!(img instanceof HTMLImageElement)) return;
	if (img.dataset.inlineSvgProcessed === "true") return;
	const src = img.getAttribute("src") || "";
	if (!src || !src.toLowerCase().includes(".svg")) return;
	img.dataset.inlineSvgProcessed = "true";
	try {
		const response = await fetch(src, { credentials: "same-origin" });
		if (!response.ok) return;
		const text = await response.text();
		if (!text || !text.includes("<svg")) return;
		const svg = new DOMParser().parseFromString(text, "image/svg+xml").querySelector("svg");
		if (!svg) return;
		const imported = document.importNode(svg, true);
		applyAttributesFromImage(img, imported);
		img.replaceWith(imported);
	} catch (_error) {}
}
function inlineAllSvgs(root = document) {
	root.querySelectorAll("img[data-inline-svg=\"true\"]").forEach((img) => {
		if (img instanceof HTMLImageElement) inlineSvgImage(img);
	});
}
document.addEventListener("DOMContentLoaded", () => {
	inlineAllSvgs(document);
});
new MutationObserver((mutations) => {
	for (const mutation of mutations) mutation.addedNodes.forEach((node) => {
		if (!(node instanceof Element)) return;
		if (node.matches?.("img[data-inline-svg=\"true\"]")) {
			if (node instanceof HTMLImageElement) inlineSvgImage(node);
		} else inlineAllSvgs(node);
	});
}).observe(document.documentElement, {
	childList: true,
	subtree: true
});
//#endregion
export { applyAttributesFromImage };
